import Modal from "@via/components/modal.tsx";
import { ModalSize } from "@via/utils/constants.tsx";
import { type UnconfirmedTermination } from "@via/pages/projects/runs/terminate-refusal";

interface TerminateWithoutConfirmationModalProps {
  open: boolean;
  setOpen: (open: boolean) => void;
  refusal: UnconfirmedTermination;
  isConfirmLoading: boolean;
  onConfirm: () => Promise<void>;
}

/**
 * Offered when the agent could not confirm that a run's job stopped. Without it such a run stays
 * active forever and can never be rerun.
 */
const TerminateWithoutConfirmationModal = ({
  open,
  setOpen,
  refusal,
  isConfirmLoading,
  onConfirm,
}: TerminateWithoutConfirmationModalProps) => (
  <Modal
    open={open}
    setOpen={setOpen}
    title="Terminate Without Confirmation"
    confirmText="Terminate Anyway"
    size={ModalSize.Large}
    onCancel={() => setOpen(false)}
    isConfirmLoading={isConfirmLoading}
    onConfirm={onConfirm}>
    <div className="mb-4 text-sm text-gray-600">
      <p>{refusal.message}</p>
      <p className="py-2">
        You can mark the run Terminated anyway. Its scheduler job may still be
        running, so check the cluster if you are not sure it stopped. The run
        log records that it was terminated without confirmation, and you can
        rerun it afterwards.
      </p>
    </div>
  </Modal>
);

export default TerminateWithoutConfirmationModal;
